
import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import RankingList from './components/RankingList';
import ComparisonTable from './components/ComparisonTable';
import StorePickup from './components/StorePickup';
import InstantGuide from './components/InstantGuide';
import RequiredDocuments from './components/RequiredDocuments';
import FAQ from './components/FAQ';
import CampaignSection from './components/CampaignSection';
import Footer from './components/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';

export default function InstantPage() {
  const [showFloatingCTA, setShowFloatingCTA] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowFloatingCTA(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "即日発行クレジットカード特集",
    "description": "最短10秒でカード番号発行！即日発行できるクレジットカードを厳選紹介。今すぐネットショッピングやスマホ決済で使えるカードが見つかります。"
  };

  return (
    <div className="min-h-screen bg-white">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
      <Header />
      <Breadcrumb items={[
        { label: 'ホーム', path: '/' },
        { label: '即日発行' }
      ]} />
      <Hero />
      <RankingList />
      <ComparisonTable />
      <StorePickup />
      <RequiredDocuments />
      <InstantGuide />
      <FAQ />
      <CampaignSection />
      <Footer />

      {/* スクロール追従CTA */}
      {showFloatingCTA && (
        <div className="fixed bottom-6 right-6 z-50 animate-bounce">
          <a
            href="#ranking"
            className="flex items-center gap-2 bg-[#DC2626] hover:bg-[#B91C1C] text-white font-bold px-6 py-4 rounded-full shadow-2xl transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-up-line"></i>
            おすすめカードを見る
          </a>
        </div>
      )}
    </div>
  );
}
